module.exports = __webpack_public_path__ + "static/media/LinkedIn.67f7f519.svg";